import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetClientReportsQuery } from "../api/reportsSlice";
import StdReportGeneration from "./std/StdReportGeneration";
import { selectIsVideoClient, selectUser, selectIsAllowedReportGeneration } from "../auth/authSlice";
import NotAuthorizedPage from "../../pages/notAuthorizedPage";
import Spinner from "../../UI/Spinner";

const ReportGenerationPage = () => {
    const { data: clientReports, refetch: refetchReportExecutionRecord } = useGetClientReportsQuery();

    const stdReports = clientReports?.filter(report => report.reportTypeId === 1);

    const user = useSelector(selectUser);
    const isVideoClient = useSelector(selectIsVideoClient);
    const isAllowedReportGeneration = useSelector(selectIsAllowedReportGeneration);

    useEffect(() => {
        if (clientReports) {
            const reportIsProcessing = (report) => {
                const completedStatuses = ["Succeeded", "Failed", "Deleted"];
                return !completedStatuses.includes(report.reportStatus);
            };
            const processingReportExists = clientReports.some(reportIsProcessing);

            if (!processingReportExists) return;

            const interval = setInterval(async () => {
                await refetchReportExecutionRecord();
            }, 3000);

            return () => clearInterval(interval);
        }

    }, [clientReports]);

    if (!user || isAllowedReportGeneration == null) return <Spinner />;
    else if (!isVideoClient || isAllowedReportGeneration === false) return <NotAuthorizedPage />;


    return (
        <div style={{ color: '#ffffff' }}>
            <StdReportGeneration reports={stdReports} />
        </div>
    );
}
export default ReportGenerationPage;
